var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
    SAVE: null,
    UPDATE_CARD: null,
    UPDATE_GROUP: null,
    NEW_PAYMENT_TOKEN_POST_SAVE: null
});



// WEBPACK FOOTER //
// ./app/constants/Token.js